import type { Dictionary } from '@witmetrics/utils';
import { DIALOGS } from '@/constants/dialogs';

export const DEFAULT_DIALOGS: Dictionary<boolean> = {
  [DIALOGS.ACCOUNTS]: false,
  [DIALOGS.LOGIN]: false,
  [DIALOGS.SEARCH]: false,
  [DIALOGS.SHORTCUTS]: false,
};
